import Carousel from './Carousel';
import Swiper, { Scrollbar, Navigation, Keyboard } from 'swiper';
Swiper.use([Scrollbar, Navigation, Keyboard]);

export default class CarouselImages extends Carousel {
	constructor(elm) {
		super(elm);
		this.init();
	}

	init() {
		const dataSlidesPerView = this.swiperContainer.getAttribute('data-slides-per-view');

		this.swiper = new Swiper(this.swiperContainer, {
			init: false,
			threshold: 2,
			navigation: {
				prevEl: this.prev,
				nextEl: this.next,
			},
			scrollbar: {
				el: this.scrollbar,
				draggable: true,
				hide: false,
			},
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
			slidesPerView: 1,
			spaceBetween: (window.innerWidth / 100) * 10,
			initialSlide: 0,
			breakpoints: {
				768: {
					slidesPerView: dataSlidesPerView,
					spaceBetween: ((window.innerWidth / 100) * 10) / dataSlidesPerView,
				},
			},
		});
		this.swiper.on('afterInit', (e) => {
			this.checkFooter();
		});

		this.swiper.on('resize', (e) => {
			this.checkFooter();
		});

		this.swiper.init();
	}

	checkFooter() {
		if (this.prev.disabled && this.next.disabled) {
			this.swiperContainer
				.closest('.section')
				.querySelector('.c-carousel-footer')
				.classList.add('c-carousel-footer--hidden');
			this.swiper.disable();
			this.swiperContainer.classList.add('swiper-disabled');
		} else {
			this.swiperContainer
				.closest('.section')
				.querySelector('.c-carousel-footer')
				.classList.remove('c-carousel-footer--hidden');
			this.swiper.enable();
			this.swiperContainer.classList.remove('swiper-disabled');
		}
		this.swiper.update();
		window.dispatchEvent(new CustomEvent('refresh-scroll'));
	}
}
